const videoTestimonials = [
  { id: 'j4pm85lpUNg', title: 'Client Testimonial 1' },
  { id: 'DkppMObe7YQ', title: 'Client Testimonial 2' },
  { id: 'hxdDkPv9x4U', title: 'Client Testimonial 3' },
  { id: 'EwhaZm-54fE', title: 'Client Testimonial 4' },
  { id: 'GyD_jxGMD_s', title: 'Client Testimonial 5' },
  { id: 'YwlwXu-2xdQ', title: 'Client Testimonial 6' },
  { id: 'vf533w_wzoE', title: 'Client Testimonial 7' },
  { id: '7WUemoog130', title: 'Client Testimonial 8' },
];

export const TestimonialsSection = () => {
  return (
    <section data-testid="testimonials-section" className="py-24 bg-[#121212] relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-1/2 left-0 w-72 h-72 bg-[#D4AF37]/5 rounded-full blur-3xl -translate-y-1/2" />
      <div className="absolute top-1/2 right-0 w-72 h-72 bg-[#D4AF37]/5 rounded-full blur-3xl -translate-y-1/2" />

      <div className="w-full px-4 sm:px-8 lg:px-16 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-12">
          <p className="font-google-sans text-[#D4AF37] text-xs tracking-[0.3em] uppercase mb-4">Client Testimonials</p>
          <h2 className="font-montserrat text-4xl sm:text-5xl text-white font-bold mb-4">
            What Our <span className="gradient-gold">Clients</span> Say
          </h2>
          <p className="font-google-sans text-[#A1A1AA] max-w-2xl mx-auto">
            Hear directly from our clients about their experience with Golden Tree Events
          </p>
        </div>

        {/* Video Grid - Embedded Videos */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {videoTestimonials.map((video, index) => (
            <div
              key={video.id}
              data-testid={`video-testimonial-${index}`}
              className="relative aspect-video bg-black rounded-xl overflow-hidden"
            >
              <iframe
                src={`https://www.youtube.com/embed/${video.id}?rel=0`}
                title={video.title}
                className="w-full h-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
